import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuex from "vuex";
import VueCookies from "vue-cookies";
import VueCryptojs from "vue-cryptojs";
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(VueCryptojs);
Vue.use(VueCookies);
Vue.use(Vuex);
Vue.config.productionTip = false;

import vSelect from "vue-select";

Vue.component("v-select", vSelect);

import numeral from 'numeral'
Vue.filter("formatNumber", function(value) {
    return numeral(value).format("0,0.00");
});

new Vue({
    watch: {
        async $route() {
            window.scrollTo(0, 0)
            if (this.$route.name == 'Login') {
                return true;
            }
            return await store.dispatch('checkAuth')
        },
    },
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");